module.exports = __webpack_public_path__ + "static/media/高分七号卫星.2d685ac6.png";